import update from 'immutability-helper'
import clsx from 'clsx'
import React, {useRef} from 'react'
import Box from '@mui/material/Box'
import useStyles from './styles'
import RadioChoice from './radio-choice'
import CheckboxChoice from './checkbox-choice'

export default function PreviewMultipleChoiceQuestion ({context, question}) {

  const {translate, quizQuestions = {}} = context
  const classes = useStyles()
  const {properties, premise, answer} = question
  const {choices = []} = answer
  console.log(answer);
  const premiseText = question.premise.html || ''
  const Choices = question.properties.singleOption ? RadioChoice : CheckboxChoice

  return (
    <Box className={clsx(classes.root, "question", "multiple-choice")}>
      <Box className={clsx(classes.premise, "premise")}>
        {premiseText != '' && (<div className="instructions" dangerouslySetInnerHTML={{__html: premiseText}} />)}
        {premiseText == '' && (<Box className={clsx('warning', 'missing-premise')}>{translate('missing-premise')}</Box>)}
      </Box>
      {choices.length > 0 && (
        <Choices
          question={question}
          context={context} 
          choices={choices}
        />)}
      {choices.length < 0 && (<Box className={clsx('warning', 'missing-choices')}>{translate('missing-choices')}</Box>)}
    </Box>
  )
}
